
<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Manage Fitness Logs</h1>
  </div>
  <div class="flex justify-end mt-3 mb-3">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for user email,activity name"
        />
      </nz-input-group>
    </div>
  </div>
  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="globalSearch()"
    >
      Search
    </button>
  </ng-template>
  <nz-table
    #fitnessLogsTable
    [nzTitle]="tableHead"
    [nzData]="tableData"
    [nzFrontPagination]="false"
    [nzLoading]="loading"
    [nzTotal]="totalRecords"
    [nzPageSize]="tableQuery.pageSize"
    [nzPageIndex]="tableQuery.page || 1"
    (nzPageIndexChange)="onPageChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="pageSizeOptions"
    nzShowPagination="true"
    nzBordered="true"
    [nzScroll]="{ y: '500px' }"
  >
    <thead>
      <tr>
        <th>User Email</th>
        <th>
          Partner
          <nz-filter-trigger
            [nzActive]="true"
            [nzDropdownMenu]="partnerDropdown"
          >
            <span nz-icon nzType="filter" nzTheme="outline"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Activity Type
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="titleDropdown">
            <span nz-icon nzType="filter" nzTheme="outline"></span>
          </nz-filter-trigger>
        </th>
        <th>Activity Name</th>
        <th>
          Status
          <nz-filter-trigger
            [nzActive]="true"
            [nzDropdownMenu]="statusDropdown"
          >
            <span nz-icon nzType="filter" nzTheme="outline"></span>
          </nz-filter-trigger>
        </th>
        <th nzWidth="30%">
          Events
          <nz-filter-trigger
            [nzActive]="true"
            [nzDropdownMenu]="eventsDropdown"
          >
            <span nz-icon nzType="filter" nzTheme="outline"></span>
          </nz-filter-trigger>
        </th>
        <th
          nzColumnKey="createdAt"
          [nzSortFn]="true"
          (nzSortOrderChange)="
            sortByColumn(FitnessLogsSortFields.CREATED_AT, $event)
          "
        >
          Created At
        </th>
        <th
          nzColumnKey="lastUpdated"
          [nzSortFn]="true"
          (nzSortOrderChange)="
            sortByColumn(FitnessLogsSortFields.LAST_UPDATED, $event)
          "
        >
          Last Updated
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of fitnessLogsTable.data">
        <td>{{ item.userEmail }}</td>
        <td>{{ item.partnerName }} ({{ item.partnerId }})</td>
        <td>
          <nz-tag
            [nzColor]="
              getActivityType(item) === 'Workout'
                ? 'green'
                : getActivityType(item) === 'Plan'
                  ? 'blue'
                  : 'purple'
            "
          >
            {{ getActivityType(item) }}
          </nz-tag>
        </td>
        <td>{{ getActivityName(item) }}</td>
        <td>
          <nz-tag
            [nzColor]="
              item.status === 'COMPLETED'
                ? 'success'
                : item.status === 'INPROGRESS'
                  ? 'processing'
                  : 'default'
            "
          >
            {{ item.status }}
          </nz-tag>
        </td>
        <td>{{ item.eventsSummary }}</td>
        <td>{{ item.createdAt | date: "medium" }}</td>
        <td>{{ item.lastUpdated | date: "medium" }}</td>
      </tr>
    </tbody>
  </nz-table>
</div>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Fitness Logs</span>
    </div>
    <div nz-col>
      <div nz-row nzAlign="middle">
        <div nz-col>
          <nz-switch
            [(ngModel)]="showTestBookings"
            (ngModelChange)="toggleTestBookings()"
            nzCheckedChildren="Hide Test Bookings"
            nzUnCheckedChildren="Show Test Bookings"
          ></nz-switch>
        </div>
        <div nz-col class="m-1">
          <button
            class="btn-color"
            (click)="exportData()"
            nz-button
            nzSize="small"
            nzType="primary"
          >
            <span nz-icon nzType="download"></span>
            Export
          </button>
        </div>
        <div nz-col class="m-1">
          <button
            class="btn-color"
            nz-button
            nzSize="small"
            nzType="primary"
            (click)="resetFilters()"
          >
            Clear filter
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<nz-dropdown-menu #partnerDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Partner</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper
          (nzOnChange)="
            applyPartnerFilter($event)
          "
        >
          <div *ngFor="let partner of partnerIdCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="partner.value"
                [ngModel]="partner.checked"
                >{{ partner.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilters()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #statusDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Status</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper
          (nzOnChange)="
            applyStatusFilter($event)
          "
        >
          <div *ngFor="let status of statusCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilters()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #eventsDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Events</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper
          (nzOnChange)="
            applyEventsFilter($event)
          "
        >
          <div *ngFor="let event of eventsCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="event.value"
                [ngModel]="event.checked"
                >{{ event.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilters()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #titleDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Activity Type</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper
          (nzOnChange)="
            applyTitleFilter($event)
          "
        >
          <div *ngFor="let title of titleCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="title.value"
                [ngModel]="title.checked"
                >{{ title.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilters()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
